import React from 'react';
import { logError } from './errorLog';

interface Props {
  moduleName: string;
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class ModuleErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: unknown, info: React.ErrorInfo): void {
    void logError({
      level: 'module',
      location: this.props.moduleName,
      message: error instanceof Error ? error.message : String(error),
      stack: info.componentStack ?? undefined,
    });
  }

  override render(): React.ReactNode {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="rounded-xl border border-orange-200 bg-orange-50 p-6">
        <div className="flex items-start gap-3">
          <span className="text-orange-500 mt-0.5">⚠</span>
          <div className="flex-1 space-y-2">
            <p className="text-sm font-medium text-orange-900">
              {this.props.moduleName} temporär nicht verfügbar
            </p>
            <p className="text-xs text-orange-700">
              Ein Fehler ist aufgetreten. Die restliche App bleibt nutzbar.
            </p>
            <button
              onClick={() => { this.setState({ hasError: false }); }}
              className="text-xs font-medium text-orange-800 underline hover:no-underline"
            >
              Modul erneut laden
            </button>
          </div>
        </div>
      </div>
    );
  }
}
